import React, { useState } from 'react';

export default function withFullscreen(
  WrappedComponent,
  { defaultHeight = 300 } = {}
) {
  return function (props) {
    const [isFullscreen, setIsFullscreen] = useState(false);
    return (
      <WrappedComponent
        {...props}
        isFullscreen={isFullscreen}
        onToggleFullscreen={() => setIsFullscreen((v) => !v)}
        fullscreenDefaultHeight={defaultHeight}
      />
    );
  };
}
